'use strict';

var rco = angular.module('gymsystem.rco', []);

rco.controller('CustomerImportCtrl', ['$rootScope', '$scope', '$http', '$timeout', 'confirm', 'server', 'util', function($rootScope, $scope, $http, $timeout, confirm, server, util) {
    $scope.isLoadingFile = false;
    $scope.option = {
        ignoreDuplicateErrors: false,
        ignoreInvalidPcode: false
    };
    var loadFile = function() {
        $scope.importedCustomers = [];
        $scope.importedNewCustomers = [];
        $scope.importedFailsMail = [];
        $scope.importedFailsPcode = [];
        $scope.importedFailsDupPcode = [];
        $scope.isLoadingFile = true;

        server.postFile('/api/member/readExcel', $scope.selectedFiles).then(function(response) {
            var result = response.data.members;
            var id=1;
            angular.forEach(result, function(member) {
                member.member = $rootScope.getMember(member.member_id);
                if (member.member) {
                    $scope.importedCustomers.push(member);
                } else {
                    var normalizedPcode = util.normalizePersonalCodeNumber(member.personalCodeNumber);
                    var duplicateMail = null;
                    var duplicatePcode = null;
                    var duplicateMemberNumber = null;
                    for (var i=0; i < result.length; ++i) {
                        var item = result[i];
                        if (item == member) {
                            continue;
                        }

                        if (member.mail && item.mail == member.mail) {
                            duplicateMail = item;
                        }
                        var p = util.normalizePersonalCodeNumber(item.personalCodeNumber);
                        if (normalizedPcode && p && normalizedPcode == p) {
                            duplicatePcode = item;
                        }

                        if (member.memberNumber && item.memberNumber == member.memberNumber) {
                            duplicateMemberNumber = item;
                        }
                    }
                    duplicateMail = duplicateMail || _.findWhere($rootScope.members, {mail: member.mail});
                    duplicateMemberNumber = duplicateMemberNumber || (member.memberNumber && _.findWhere($rootScope.members, {memberNumber: member.memberNumber}));

                    var invalidPersonalCode = member.personalCodeNumber && !util.isValidPersonalCode(member.personalCodeNumber);

                    if (!member.company) {
                        if (!member.lastname) {
                            member.lastname = '?';
                        }
                        if (!member.firstname) {
                            member.firstname = '?';
                        }
                    }
                    member.fullname = member.firstname ? (member.firstname + " " + member.lastname) : member.lastname;
                    member.id = ++id;

                    if (duplicateMail) {
                        $scope.importedFailsMail.push(member);
                    } else if (invalidPersonalCode) {
                        if ($scope.option.ignoreInvalidPcode) {
                            member.extraInfo += '\n' + member.personalCodeNumber;
                            member.personalCodeNumber = null;
                            $scope.importedNewCustomers.push(member);
                        } else {
                            $scope.importedFailsPcode.push(member);
                        }
                    } else if (duplicatePcode) {
                        if ($scope.option.ignoreDuplicateErrors) {
                            member.extraInfo += '\n' + member.personalCodeNumber;
                            member.personalCodeNumber = null;
                            $scope.importedNewCustomers.push(member);
                        } else {
                            $scope.importedFailsDupPcode.push(member);
                        }
                    } else if (duplicateMemberNumber) {
                        $scope.importedFailsMemberNumber.push(member);
                    } else {
                        $scope.importedNewCustomers.push(member);
                    }
                }
            });

            $scope.isLoadingFile = false;
        });
    };

    $scope.waitingWatch = $scope.$watch('selectedFiles', function(newValue) {
        if (newValue) {
            loadFile();
        }
    });

    $scope.resetFiles = function() {
        $scope.selectedFiles = undefined;
        $scope.importedCustomers = [];
        $scope.importedNewCustomers = [];
        $scope.importedFailsMail = [];
        $scope.importedFailsPcode = [];
        $scope.importedFailsDupPcode = [];
        $scope.importedFailsMemberNumber = [];
    };

    $scope.addCustomer = function(customer) {
        server.post('/api/member/multiAdd', [customer], null, 'Customer added', 'Failed to add customer').then(function(result) {
            if (result.success) {
                var i = $scope.importedNewCustomers.indexOf(customer);
                $scope.importedNewCustomers.splice(i, 1);
                $scope.importedCustomers.push(customer);
            }
        });
    };

    $scope.importAll = function() {
        $scope.isImportAll = true;
        server.post('/api/member/multiAdd', $scope.importedNewCustomers, null, 'Customers imported', 'Failed to import customers').then(function() {
            $scope.resetFiles();
            $scope.isImportAll = false;
        });
    };
    $scope.importedCustomers = [];
    $scope.importedCustomersControl = {};
    $scope.importedCustomersConfig = {
        getItems: function() {
            return $scope.importedCustomers;
        },
        countSuffix: function() {
            return 'customers';
        },
        rowClick: function(member) {
            $rootScope.gotoCustomer(member.member);
        },
        columns: [
            {field: 'image', title: '', src: function(m) { return $scope.smallMemberImage(m.member); }  },
            {field: 'name', title: 'Name' },
            {field: 'mail', title: 'E-mail' },
            {field: 'personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' }
        ]
    };

    $scope.importedNewCustomers = [];
    $scope.importedNewCustomersControl = {};
    $scope.importedNewCustomersConfig = {
        getItems: function() {
            return $scope.importedNewCustomers;
        },
        countSuffix: function() {
            return 'customers';
        },
        columns: [
            {field: 'fullname', title: 'Name' },
            {field: 'mail', title: 'E-mail' },
            {field: 'personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
            {field: 'trainingcard', title: 'Training card'},
            {field: 'membership', title: 'Membership'}
        ],
        buttons: [
            { title: 'Add customer', buttonClass: 'btn-success', onClick: $scope.addCustomer }
        ]
    };

    $scope.importedFailsMail = [];
    $scope.importedFailsMailControl = {};
    $scope.importedFailsMailConfig = angular.copy($scope.importedNewCustomersConfig);
    $scope.importedFailsMailConfig.buttons = null;
    $scope.importedFailsMailConfig.getItems = function() {
        return $scope.importedFailsMail;
    };

    $scope.importedFailsPcode = [];
    $scope.importedFailsPcodeControl = {};
    $scope.importedFailsPcodeConfig = angular.copy($scope.importedFailsMailConfig);
    $scope.importedFailsPcodeConfig.getItems = function() {
        return $scope.importedFailsPcode;
    };

    $scope.importedFailsDupPcode = [];
    $scope.importedFailsDupPcodeControl = {};
    $scope.importedFailsDupPcodeConfig = angular.copy($scope.importedFailsMailConfig);
    $scope.importedFailsDupPcodeConfig.getItems = function() {
        return $scope.importedFailsDupPcode;
    };

    $scope.importedFailsMemberNumber = [];
    $scope.importedFailsMemberNumberControl = {};
    $scope.importedFailsMemberNumberConfig = angular.copy($scope.importedFailsMailConfig);
    $scope.importedFailsMemberNumberConfig.getItems = function() {
        return $scope.importedFailsMemberNumber;
    };
    $scope.importedFailsMemberNumberConfig.columns = [
        {field: 'name', title: 'Name' },
        {field: 'mail', title: 'E-mail' },
        {field: 'memberNumber', title: 'Member number' }
    ];
}]);


rco.controller('RcoCustomerImportCtrl', ['$scope', 'live', 'server', 'alertProvider', function($scope, live, server, alertProvider) {
    $scope.loadingStatus = {};

    $scope.fetchUsers = function() {
        $scope.loadingStatus.fetching = true;
        live.pluginCommand('Rco', 'GetUsers').then(function(users) {
            $scope.loadingStatus.fetching = false;
            if (!users) {
                alertProvider.show('error', 'Failed to get data');
                return;
            }
            $scope.importedCustomers = [];
            angular.forEach(users, function(user) {
                var u = {};
                u.firstname = user.FirstName;
                u.lastname = user.LastName;
                var card = user.Cards && user.Cards.length && user.Cards[0];
                u.cardId = card && card.CardIdentity;
                u.validFromDate = Date.newFull(card.ValidFromDate);
                u.validToDate = Date.newFull(card.ValidToDate);
                u.trainingcard = card && card.Template;
                u.pin = card && card.PinCode;
                u.phone = user.Phone;
                u.oldphone = user.OldPhone;
                u.mail = user.Mail;
                u.zipCode = user.PostalCode;
                u.city = user.City;
                u.address = user.Address;
                u.extraInfo = user.Extra;
                u.entries = user.Entries;
                if (!user.RaPkExternal) {
                    $scope.importedCustomers.push(u);
                }
            });
        });
    };

    $scope.importAll = function() {
        $scope.loadingStatus.importing = true;
        server.post('/api/user/old_multiadd', $scope.importedCustomers, null, 'Customers imported', 'Failed to import customers').then(function(result) {
            if (result.success) {
                $scope.importedCustomers = null;
            }
            $scope.loadingStatus.importing = false;
        });
    };

    $scope.importedCustomersConfig = {
        getItems: function() {
            return $scope.importedCustomers;
        },
        countSuffix: function() {
            return 'customers';
        },
        columns: [
            {field: 'firstname', title: 'First name' },
            {field: 'lastname', title: 'Last name' },
            {field: 'mail', title: 'E-mail' },
            {field: 'entries', title: 'Entries', getValue: function(x) { return x.entries.length; } },
            {field: 'cardId', title: 'Card id' },
            {field: 'validFromDate', title: 'Valid from', format: 'date' },
            {field: 'validToDate', title: 'Valid to', format: 'date' },
            {field: 'phone', title: 'Phone' },
            {field: 'oldphone', title: 'Old phone' },
            {field: 'extraInfo', title: 'Extra information' }
        ]
    };
}]);

rco.controller('RcoDoorImportCtrl', ['$rootScope', '$scope', '$modal', 'live', 'alertProvider', 'resourceTypes', function($rootScope, $scope, $modal, live, alertProvider, resourceTypes) {
    $scope.loadingStatus = {};

    $scope.fetchDoors = function() {
        $scope.loadingStatus.fetching = true;
        live.pluginCommand('Rco', 'GetDoors').then(function(doors) {
            $scope.loadingStatus.fetching = false;
            if (!doors) {
                alertProvider.show('error', 'Failed to get data');
                return;
            }
            $scope.importedDoors = doors;
        });
    };

    var addDoor = function(door) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ResourceBookingResourceAddModalCtrl',
            resolve: {
                options: function() {
                    return {
                        resourceType: _.findWhere(resourceTypes.get(), {id: 'door'}),
                        externaldoorid: door.id,
                        name: door.name
                    };
                }
            }
        });
    };

    $scope.importedDoorsConfig = {
        getItems: function() {
            return $scope.importedDoors;
        },
        triggers: ['user'],
        countSuffix: function() {
            return 'doors';
        },
        itemFilter: function(door) {
            return !_.findWhere($rootScope.staffs, {externaldoorid: String(door.id) });
        },
        columns: [
            {field: 'name', title: 'Name' },
            {field: 'id', title: 'External door id' }
        ],
        buttons: [
            { title: 'Add door', onClick: addDoor }
        ]
    };
}]);

rco.controller('SettingsRcoCtrl', ['$rootScope', '$scope', '$controller', 'server', 'live', 'alertProvider', 'confirm', function($rootScope, $scope, $controller, server, live, alertProvider, confirm) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.title = "Rco settings";
    $scope.getUrl = '/api/settings/rco/get';
    $scope.postUrl = '/api/settings/rco/set';

    $scope.fields = [
    ];
    $scope.rightPanel = '/views/rcocontrol.html';

    $scope.sync = function() {
        $scope.loadingStatus.syncing = true;
        server.post('/api/rco/sync', null, null, 'Customers synced', 'Failed to sync customers').then(function() {
            $scope.loadingStatus.syncing = false;
        });
    };

    $scope.remove = function() {
        $scope.loadingStatus.removing = true;
        confirm.show('Are you sure you want to remove all non-Gymsystem users from the RCO database?').then(function() {
            live.pluginCommand('Rco', 'RemoveRcoUsers').then(function(result) {
                $scope.loadingStatus.removing = false;
                if (!result)
                {
                    alertProvider.show('error', 'Failed to perform operation');
                    return;
                }
                alertProvider.show('success', 'Users removed');
            });
        });
    };

    $scope.getSettings();
}]);
